export type DensityMapLayerStyle = {
  fillHSL: [number, number, number];
  floorColor: string;
  floorOpacity: number;
}

export type ConfiguratorData = {
  mapStyle?: string;
  camera?: mapboxgl.CameraOptions;
  excludeLevels?: string[];
  autopilotUpdateInterval?: number;
  maxSpaceDensity?: number;
  scale?: {
    base: number;
    maxHeight: number;
    minHeight: number;
    gap: number;
  };
  layerStyles: DensityMapLayerStyle[];
}

export type DensityMapConfigurator = Required<ConfiguratorData> & {
  getLayerStyle: (layerNumber: number) => DensityMapLayerStyle;
  getYScale: (layerNumber?: number) =>  {
    base: number;
    minHeight: number;
    maxHeight: number;
  };
};

export { DensityMap } from './density-map';
export { getConfigurator } from './configurator'